<template>
  <div class="card">
    <template v-if="hasHeaderSlot">
      <div class="content card-header" :class="{'card-padding': hasHeaderPadding }">
        <slot name="header"></slot>
      </div>
    </template>
    <overflow-menu v-if="hasMenu && !customMenu" :on-menu-opened="onMenuOpened">
      <template v-slot:menuItems><slot name="menuItems"/></template>
    </overflow-menu>
    <div v-else-if="hasMenu && customMenu" class="custom-actions"><slot name="menuItems"/></div>

    <div class="content card-body" :class="{'card-padding': hasContentPadding}">
      <slot></slot>
    </div>

    <template v-if="hasFooterSlot">
      <separator v-if="showSeparatorOnFooter"/>

      <div class="content card-footer" :class="{'card-padding': hasFooterPadding}">
        <slot name="footer"></slot>
      </div>
    </template>
  </div>
</template>

<script>

import Separator from '../Separator.vue';

const OverflowMenu = () => import('../OverflowMenu/OverflowMenu.vue');

export default {
  name: 'Card',
  components: { Separator, OverflowMenu },
  props: {
    hasFooterPadding: {
      type: Boolean,
      default: true,
    },
    hasHeaderPadding: {
      type: Boolean,
      default: true,
    },
    hasContentPadding: {
      type: Boolean,
      default: true,
    },
    onMenuOpened: {
      type: Function,
      required: false,
    },
    showSeparatorOnFooter: {
      type: Boolean,
      default: true,
    },
    customMenu: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
    hasMenu() {
      return !!this.$slots.menuItems;
    },
    hasHeaderSlot() {
      return !!this.$slots.header;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './card-styles';

</style>
